<article class="fulfillment-status-bar">
  <ul class="fulfillment-status-list">
    @for (status of statuses; track status; let i = $index) {
      <li
        class="fulfillment-status-list__item"
        [ngClass]="'border-' + statuses[i < statuses.length - 1 ? i + 1 : i].color"
        [class.is--hide-mobile]="!lastActiveStep(status) && detailsHidden"
        [class.is--collapsed]="detailsHidden"
        >
        <article class="fulfillment-status">
          <app-icon [anchor]="status.icon" class="fulfillment-status icon-lg" [ngClass]="'icon-' + status.color"></app-icon>
          <span>
            <strong class="fulfillment-status__title" [ngClass]="'text-' + status.color">
              {{ getLabel('', status.title, status.title) }}
            </strong>
            @if (status.date) {
              <p class="mb-0 text-dark type-body-sm">{{ status.date | date }}</p>
            }
            @if (getLabel('', status.text, '')) {
              <p class="mb-0 text-dark type-body-sm">{{ getLabel('', status.text) }}</p>
            }
            @if (status.fulfillments?.length) {
              <ul>
                @for (item of status.fulfillments; track item) {
                  <li>
                    @if (status.fulfillments?.length === 1) {
                      <p class="mb-1 type-body-sm">
                        @if (item.trackingCompany) {
                          {{ prefix + '-tracking-bedrijf-prefix' | fromDictionary }} {{ item.trackingCompany }}
                        }
                        <br />
                        @for (tracking of item.trackingInfo; track tracking) {
                          <a class="type-body-sm" [href]="tracking.url" target="_blank">
                            {{ tracking.number }}
                          </a>
                        }
                      </p>
                    }
                    @if (status.fulfillments!.length > 1) {
                      <div>
                        <strong class="type-body-sm">{{ item.trackingCompany }}</strong>
                        @for (tracking of item.trackingInfo; track tracking) {
                          <a class="type-body-sm" [href]="tracking.url" target="_blank">
                            {{ tracking.number }}
                          </a>
                        }
                      </div>
                    }
                  </li>
                }
              </ul>
            }
          </span>
        </article>
      </li>
    }
  </ul>

  <footer class="fulfillment-status-bar__footer">
    <button
      class="d-md-none button button-sm button--secondary mt-3"
      [class.button-link]="!detailsHidden"
      (click)="toggleStatusDetailsMobile()"
      >
      <app-icon [anchor]="detailsHidden ? 'icon-plus' : 'icon-minus'" [class.icon-xs]="!detailsHidden"></app-icon>
      @if (detailsHidden) {
        <span>{{ prefix + '-toon-geschiedenis' | fromDictionary }}</span>
      }
      @if (!detailsHidden) {
        <span>{{ prefix + '-verberg-geschiedenis' | fromDictionary }}</span>
      }
    </button>
  </footer>
</article>
